import React from 'react';
import '../../pages/Service/ServicesPage.css'
import { Link } from 'react-router-dom';
import { ButtomGet } from '../ButtomGet/ButtomGet';



const Service = () => (
    <section className="servicios" id="servicios">
        <h2 className="heading">Services</h2>
        <div className="row">
            <div className="columns" data-aos="fade-up" data-aos-delay="200">
                <i className="fas fa-drafting-compass"></i>
                <h3>Design UX/UI</h3>
                <p>Design of attractive interfaces for both web and mobile users, making the most of the brand or product that the client wishes to exploit on their website</p>
            </div>
            <div className="columns" data-aos="fade-up" data-aos-delay="300">
                <i className="fas fa-laptop"></i>
                <h3>Web development</h3>
                <p>Creation of well-structured web pages, good responsive design, attractive color palette, with interactions that give the user satisfaction when browsing the website.</p>
            </div>
            <div className="columns" data-aos="fade-up" data-aos-delay="400">
                <i className="fas fa-chart-line"></i>
                <h3>Digital marketing</h3>
                <p>Prepare a strategy and objectives for the promotion of the brand provided by the client, using the internet or other platforms to promote products and services of the brand in question.</p>
            </div>
            <div className="columns" data-aos="fade-up" data-aos-delay="500">
                <i className="fas fa-wrench"></i>
                <h3>Web maintenance</h3>
                <p>Complete maintenance of web pages to detect and solve errors, update content whether text, photos, web design elements, add new functions, etc.</p>
            </div>
            <div className="columns" data-aos="fade-up" data-aos-delay="600">
                <i className="fas fa-search"></i>
                <h3>Web positioning (SEO)</h3>
                <p>Web positioning through SEO, so your website appears in the main search results according to your business, both in Google, Bing, or other internet search engines</p>
            </div>
            <div className="columns" data-aos="fade-up" data-aos-delay="700">
                <i className="fas fa-tachometer-alt"></i>
                <h3>Website optimization</h3>
                <p>Complete optimization of your web page, improving loading speed, using optimized images, a good URL, to give a better experience to users who visit the website</p>
            </div>
            <div className="columns" data-aos="fade-up" data-aos-delay="800">
                <i className="fas fa-shopping-cart"></i>
                <h3>E-commerce Development</h3>
                <p>Complete e-commerce solutions with secure payment gateways, inventory management, and user-friendly shopping experiences to boost your online sales.</p>
            </div>
            <div className="columns" data-aos="fade-up" data-aos-delay="900">
                <i className="fas fa-database"></i>
                <h3>Database Management</h3>
                <p>Design, implementation, and management of robust database systems to ensure efficient data storage, retrieval, and security for your applications.</p>
            </div>
        </div>
        <div className='portafolio-btn'>
            <Link to="/service">
                <ButtomGet/>
            </Link>
        </div>
    </section>
);

export default React.memo(Service);